import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { TarifCreateModal } from "@/components/backOffice/parameters/tarifs/tarifCreateModal";
import { TarifsTable } from "@/components/backOffice/parameters/tarifs/tarifsTable";
import { useState } from "react";
import { useGetTarifs } from "@/api/tarif.api";
import { Loader2 } from "lucide-react";
import { ParametersHeader } from "@/components/shared/parametersHeader";

export const TarifsPage = () => {
  const { t } = useTranslation("boParameters");
  const [open, setOpen] = useState(false);
  const { data: tarifs, isPending } = useGetTarifs({
    isExpress: false,
    take: 1000,
  });

  if (isPending) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="h-4 w-4 animate-spin" />
      </div>
    );
  }

  return (
    <ParametersHeader>
      <div className="flex flex-col gap-6 lg:px-8">
        <div className="flex flex-row items-start justify-between">
          <div className="flex flex-col gap-2">
            <h2 className="text-lg font-semibold">{t("tarifsPage.title")}</h2>
            <p className="text-sm text-gray-600">{t("tarifsPage.description")}</p>
          </div>
          <Button onClick={() => setOpen(true)}>{t("tarifsPage.create")}</Button>
        </div>
        <TarifsTable />
        <TarifCreateModal
          open={open}
          closeModal={() => setOpen(false)}
          tarifs={tarifs?.data ?? []}
        />
      </div>
    </ParametersHeader>
  );
};
